class fl_html_select {

    constructor(id, template) {
        /*
            The select_id is the id of the original select which this class will
            replace with a html drop down box.
         */
        this.select_id = id;

        /*
        The template is an html file which defines the content of the li items in the
        html dropdown box.
         */
        this.template = $('#' + template);

        /*
        Flag to remember whether this.create_container_html() was already performed
         */
        this.container_created = false;

        this.cookie = new cookie();
    }


    /*
    Initiate this javascript class
     */
    init() {
        this.create_select_onchange_event();
        this.create_container_html();
        this.fill_html();
        this.close_click_outside();
    }

    close_click_outside() {
        var elem = document.querySelector('#' + this.select_id + '_container');
        const self = this;

        document.addEventListener('click', function (event) {
            if (elem.contains(event.target)) {
                return false;
            } else {
                const elem_divs = $('#' + self.select_id + '_container .inner-div-flhtmls');
                elem_divs.hide();
                $('#' + self.select_id + '_container').removeClass('shadow');
            }
        });
    }

    sync() {
        this.show_all();
        this.hide();
        this.select();
    }

    show_all() {
        $('#' + this.select_id + '-flhtmls-ul li').removeClass('hidden');
    }

    hide() {

        /*
           Get hidden original select options
            */
        var hidden_gs = $('#' + this.select_id + ' option.hidden').map(function () {
            return $(this).data('i')
        });

        var self = this;

        $.each(hidden_gs, function (index_array, index_gs) {
            $('#' + self.select_id + '_' + index_gs).addClass('hidden');
        });

    }

    select() {
        var value = $('#' + this.select_id).val();
        var selected_index = $('#' + this.select_id + ' option[value="' + value + '"]').data('i');
        $('#' + this.select_id + '-flhtmls-ul li').removeClass('selected');
        $('#' + this.select_id + '_' + selected_index).addClass('selected');

        this.update_selected_li(selected_index);
    }

    create_select_onchange_event() {
        // return;
        var self = this
        $('#' + this.select_id).on('change', function () {
            var selector = "#" + self.select_id + "_" + this.value;
            selector = selector.replace('.', '\\.');
        });
    }

    /*
    Generate the extra html to make a simple select into a select where you are free
    to use html with images, own css, etc.
     */
    create_container_html() {
        /*
        - the button is the dropdown when closed
        - the inner-div-flhtmls (flhtmls = featherlight image select, fl_html_select) is the div in which the dropdown list will come
        - in there, there will be a html unordered list (ul)
        - the elements in the el, the values for the original select box, will be created with a html template and data to fill it. This is done in
        this.fill_html();
         */

        if (this.container_created) {
            return;
        }

        var html = '<div class="container-div-flhtmls">' +
            '<ul class="btn-flhtmls" id="' + this.select_id + '-btn-flhtmls" value=""></ul>' +
            '<div class="inner-div-flhtmls" id="' + this.select_id + '-inner-div-flhtmls"><ul class="flhtmls-ul" id="' + this.select_id + '-flhtmls-ul"></ul></div>' +
            '</div>';
        $('#' + this.select_id + '_container').append(html);

        this.open_list_event();
        this.container_created = true;

    };


    /*
    Fill the html dropdown with enriched data from the get_li_data function.
    The function get_li_data is generated by the user after defining an instance
    of this class. This for flexibility: because the data and the template are external
    from this class, the user of this class is free to do what he wants in the html dropdown.
     */
    fill_html() {
        // put the whole class in the self variable for use within jquery functions where
        // this is something in the jquery function itself.
        var self = this;

        /*
        Generate an array of content objects for the html dropdown
        these objects will be the input data for the html template
        which will be used
         */
        var li_data_array = [];
        $('#' + this.select_id + ' option').each(function () {
            var li_data = self.get_li_data($(this).data('i'));
            li_data_array.push(li_data);
        })

        /*
        When the array of contents is ready, this will be fed to the template which will generate
        the li items. After this is done, a click event will be attached by this.set_li_events()
         */
        var options = {
            overwriteCache: true,
            elemPerPage: 1000,
            async: false,
            success: function () {
                self.set_li_events();
                // Process initial selection for mounting parts
                if (self.select_id.startsWith('mp_') && typeof window.extensionHandler !== 'undefined') {
                    const currentValue = $('#' + self.select_id).val();
                    const selectedIndex = $('#' + self.select_id + ' option[value="' + currentValue + '"]').data('i');
                    if (selectedIndex !== undefined) {
                        const dropDownMp = window.cf ? window.cf['drop_down_' + self.select_id.replace('mp_', '')] : null;
                        if (dropDownMp) {
                            if (typeof dropDownMp.processExtensions === 'function') {
                                dropDownMp.processExtensions();
                            }
                            if (typeof dropDownMp.processSelectedItem === 'function') {
                                dropDownMp.processSelectedItem(selectedIndex, self.select_id);
                            }
                        }
                    }
                }
            }
        };

        /*
        Load the template for the whole array of content objects
         */
        $('#' + this.select_id + '-flhtmls-ul').loadTemplate(this.template, li_data_array, options);

    };

    set_li_events() {
        var select_id = this.select_id;
        var self = this;

        $('#' + select_id + '-flhtmls-ul li').click(async function (event) {

            if (!$(event.target).closest('.show_2d_cad_dd, .show_3d_cad_dd').length) {

                // the value of the original select is thus found by removing the select id and the "_"
                var index = $(this).attr('id').replace(select_id + "_", "");
                // console.log('set_li_events index: ', index);

                // change the selected value of the original select box and trigger the onchange function
                var value = $('#' + select_id + ' option[data-i="' + index + '"]').val();
                $('#' + select_id + '').val(value).change();
                // let the html dropdown close
                $('#' + select_id + '-inner-div-flhtmls').toggle();
                $('#' + select_id + '_container').removeClass('shadow');

                self.select(index);
            }
        });

        /*
        And load the list for the first time
         */
        $('#' + select_id).change();

    }

    update_selected_li(selected_index) {
        var $sourceLi = $('#' + this.select_id + '_' + selected_index);
        var li_html = '<li class="flhtmls-li">' + $sourceLi.html() + '</li>';
        $('#' + this.select_id + '-btn-flhtmls').html(li_html);
        
        // Process extensions for the selected item if it's a mounting part
        if (this.select_id.startsWith('mp_') && typeof window.extensionHandler !== 'undefined') {
            const dropDownMp = window.cf ? window.cf['drop_down_' + this.select_id.replace('mp_', '')] : null;
            if (dropDownMp && typeof dropDownMp.processSelectedItem === 'function') {
                dropDownMp.processSelectedItem(selected_index, this.select_id);
            }
        }
    }

    open_list_event() {
        var self = this;
        let $select_elem = $('#' + self.select_id)

        // attach an event to a click on the button
        $('#' + self.select_id + '-btn-flhtmls').click(function (event) {
            // 2D/3D icons live inside the summary card; do not toggle the dropdown when they are clicked.
            if ($(event.target).closest('.show_2d_cad_dd, .show_3d_cad_dd, .show_2d_cad, .show_3d_cad').length) {
                return;
            }

            let visible = $('#' + self.select_id + '-inner-div-flhtmls').is(':visible');

            // dont open the dropdown if the container has 'disabled-no-click' class
            let $elem = $('#' + self.select_id);
            let $mp_type_wanted = $("input[name='" + self.select_id + "_type']").val();
            if (
                $elem.hasClass('disabled-no-click') ||
                $select_elem.val() === 'none' &&
                $mp_type_wanted !== 'none'
            ) {
                $('#' + self.select_id + '-btn-flhtmls').addClass('disabled-no-click');
                return;
            } else {
                $('#' + self.select_id + '-btn-flhtmls').removeClass('disabled-no-click');
            }

            // close the dropdown if it's opened and your clicking on it
            if (visible == true) {
                $('#' + self.select_id + '-inner-div-flhtmls').hide();
            } else {
                // let the html dropdown open
                $('#' + self.select_id + '-inner-div-flhtmls').toggle();
                $('#' + self.select_id + '_container').addClass('shadow');

                if (self.select_id === 'mp_rod' &&
                    window.cf &&
                    window.cf.drop_down_rod &&
                    typeof window.cf.drop_down_rod.processExtensions === 'function') {
                    window.cf.drop_down_rod.processExtensions();
                }

                $("#" + self.select_id + "-flhtmls-ul li.selected")[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                });
            }
        });

    }

}